import ModelBase from "../../../../framework/core/mvvm/model_base";
import { K9 } from "./k9_data";
import { K9Proto } from "../../net/proto/proto_k9_game";
import UserDataManager from "../../../../manager/user_manager";
import { IUserData } from "../../../public/model_data";
import { NetMsgK9 } from "../../net/net_msg_data_map_k9";
import LanguageManager from "../../../../manager/language_manager";
import K9Help from "./component/k9_help";
import TableBaseModel from "../../../table/module/table_base/table_base_model";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9TableModel extends TableBaseModel {

    seatData:K9.SeatData[] = [];//不包含庄家数据

    bankData:K9.SeatBankData = null;//庄家数据

    commonData:K9.CommonData = null;

    send_BetReq(betRate:number){
        let data:K9Proto.IBetReq = {
            betRate:betRate
        }
        this.sendMsg(NetMsgK9.BetReq,data);
    }

    send_Leave(){
        this.sendMsg(NetMsgK9.LeaveRoom,{});
    }

    send_MoreCard(isNeedCard:boolean){
        let data:K9Proto.IMoreCardReq = {
            noMoreCard:!isNeedCard,//true 不要牌  false 要牌
        }
        this.sendMsg(NetMsgK9.MoreCardReq,data)
    }

    send_Ack(){
        if (!this.commonData) {
            return;
        }
        if (this.commonData.event == 0) {
            return;
        }
        this.commonData.event = 0;
        let data:K9Proto.IAckReq = {
            ackId:this.commonData.ackId,
        }
        this.sendMsg(NetMsgK9.AckReq,data);
    }

    //true表示申请 false表示取消申请
    send_Banker(isreq:boolean){
        let data:K9Proto.IBankerReq = {
            isReq:isreq,
        }
        this.sendMsg(NetMsgK9.Banker,data);
    }

    //查找pos -- playerid
    findSeatData(v:number,ispos:boolean = true):K9.SeatData{
        if (!this.seatData) {
            cc.log('-->>>>seatData is null!')
            return null;
        }
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (ispos) {
                    if (data.seat_pos === v) {
                        return data;
                    }
                }else{
                    if (data.player_id === v) {
                        return data;
                    }
                }
                
            }
        }
        return null;
    }

    //移除
    removeSeatInfo(playerID:number){
        if (!this.seatData) {
            return;
        }
        for (let index = 0; index < this.seatData.length; index++) {
            let data = this.seatData[index];
            if (data) {
                if (data.player_id == playerID) {
                    this.seatData.splice(index,1);
                    break;
                }
            }
        }
    }

    //新增
    pushSeatInfo(seatData:K9Proto.ISeatInfo):K9.SeatData{
        let data = this.initSeatData(seatData);
        this.removeSeatInfo(data.player_id);
        this.seatData.push(data);
        return data;
    }

    initSeatData(seatData:K9Proto.ISeatInfo):K9.SeatData{
        let data = new K9.SeatData();
        data.seat_pos = seatData.seatId;
        data.player_id = seatData.playerId;
        if (seatData.playerId != 0) {
            data.name = this.setPlayerData(seatData.userJson,seatData.playerId);
            data.userJson = seatData.userJson;
        }else{
            data.name = LanguageManager.t('k9_banker');
        }
        data.coin_balance = seatData.coinBalance;
        data.state = seatData.state;
        data.bet_coin = seatData.betCoin;
        data.cards = seatData.cards;
        K9Help.sortCards(data.cards);
        data.card_type = seatData.cardType;
        data.card_point = seatData.cardPoint;
        data.win_rate = seatData.winRate;
        data.balance = seatData.balance;
        data.real_balance = seatData.realBalance;
        return data;
    }

    changeBankData(seatData:K9Proto.ISeatInfo):K9.SeatBankData{
        if (!seatData || !this.bankData) {
            return;
        }
        this.bankData.coin_balance = seatData.coinBalance;
        this.bankData.state = seatData.state;
        this.bankData.bet_coin = seatData.betCoin;
        this.bankData.cards = seatData.cards;
        K9Help.sortCards(this.bankData.cards);
        this.bankData.card_type = seatData.cardType;
        this.bankData.card_point = seatData.cardPoint;
        this.bankData.win_rate = seatData.winRate;
        this.bankData.balance = seatData.balance;
        this.bankData.real_balance = seatData.realBalance;
    }

    //更改玩家数据
    changeSeatInfo(seatData:K9Proto.ISeatInfo){
        if (seatData) {
            this.pushSeatInfo(seatData);
        }else{
            cc.warn('数据异常',seatData.playerId,this.seatData);
        }
    }

    protected setPlayerData(str:string,playid:number):string{
        UserDataManager.setUserJsonData(str);
        let userdata : IUserData = UserDataManager._userDatas[playid.toString()]
        if (userdata) {
            return userdata.name;
        }
        return '';
    }

    //重置数据
    reset(){
        this.seatData = [];
    }
}
